function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tinymce from '@/components/Tinymce/index';
import { productDetailApi } from '@/api/store';
import { shippingTemplatesList } from '@/api/logistics';
import { bargainSaveApi } from '@/api/marketing';
import { Debounce } from '@/utils/validate';
export default {
  name: 'creatBargainMore',
  components: {
    Tinymce: Tinymce
  },
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < new Date().setTime(new Date().getTime() - 3600 * 1000 * 24);
        }
      },
      baseForm: {
        timeVal: [],
        peopleNum: 1,
        bargainNum: 2,
        num: 1,
        tempId: '',
        status: 0
      },
      baseRules: {
        timeVal: [{
          required: true,
          message: '请选择活动日期',
          trigger: 'change',
          type: 'array'
        }],
        peopleNum: [{
          required: true,
          message: '请输入砍价人数',
          trigger: 'blur'
        }],
        bargainNum: [{
          required: true,
          message: '请输入帮砍次数',
          trigger: 'blur'
        }],
        num: [{
          required: true,
          message: '请输入购买数量限制',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }]
      },
      shippingList: [],
      productList: [],
      editVisible: false,
      editProduct: null,
      editTab: 'base',
      editRules: {
        image: [{
          required: true,
          message: '请上传商品主图',
          trigger: 'change'
        }],
        imagess: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入砍价活动名称',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }]
      },
      fullscreenLoading: false,
      loading: false
    };
  },
  mounted: function mounted() {
    this.getShippingList();
  },
  methods: {
    getShippingList: function getShippingList() {
      var _this2 = this;
      shippingTemplatesList({
        page: 1,
        limit: 9999
      }).then(function (res) {
        _this2.shippingList = res.list;
        // 默认选中自提配送运费模板（id=3）
        var zt = (res.list || []).find(function (t) {
          return Number(t.id) === 3;
        });
        if (zt) _this2.baseForm.tempId = zt.id;
      });
    },
    addGoods: function addGoods() {
      var _this = this;
      this.$modalGoodList(function (rows) {
        _this.mergeProducts(rows);
      }, 'many', _this.productList.map(function (item) {
        return {
          id: item.productId,
          image: item.image
        };
      }));
    },
    mergeProducts: function mergeProducts(rows) {
      var _this3 = this;
      var existIds = this.productList.map(function (item) {
        return item.productId;
      });
      var selectedIds = rows.map(function (row) {
        return Number(row.id);
      });
      this.productList = this.productList.filter(function (item) {
        return selectedIds.indexOf(item.productId) > -1;
      });
      var toAdd = rows.filter(function (row) {
        return existIds.indexOf(Number(row.id)) === -1;
      });
      if (!toAdd.length) return;
      this.fullscreenLoading = true;
      Promise.all(toAdd.map(function (row) {
        return _this3.loadProduct(row.id);
      })).then(function (items) {
        items.forEach(function (item) {
          return item && _this3.productList.push(item);
        });
        _this3.fullscreenLoading = false;
      }).catch(function () {
        _this3.fullscreenLoading = false;
      });
    },
    loadProduct: function loadProduct(id) {
      var _this4 = this;
      return productDetailApi(id).then(function (info) {
        var imagess = [];
        try {
          imagess = JSON.parse(info.sliderImage) || [];
        } catch (e) {
          imagess = [];
        }
        var specAttrs = info.specType && Array.isArray(info.attr) ? info.attr.map(function (a) {
          return a.attrName;
        }) : [];
        var skuList = (info.attrValue || []).map(function (row) {
          var sku = Object.assign({}, row);
          if (info.specType && typeof sku.attrValue === 'string') {
            try {
              sku.attrValue = JSON.parse(sku.attrValue);
            } catch (e) {
              sku.attrValue = {};
            }
          }
          if (info.specType && sku.attrValue && _typeof(sku.attrValue) === 'object') {
            for (var k in sku.attrValue) {
              sku[k] = sku.attrValue[k];
            }
          }
          sku.image = _this4.$selfUtil.setDomain(sku.image);
          sku.quota = sku.stock;
          sku.price = sku.price || 0;
          sku.minPrice = sku.minPrice || 0;
          return sku;
        });
        return {
          productId: info.id,
          storeName: info.storeName,
          image: _this4.$selfUtil.setDomain(info.image),
          imagess: imagess,
          title: info.storeName,
          unitName: info.unitName,
          sort: info.sort,
          tempId: info.tempId,
          attr: info.attr,
          specAttrs: specAttrs,
          selectRule: info.selectRule,
          content: info.content,
          specType: info.specType,
          giveIntegral: info.giveIntegral,
          ficti: info.ficti,
          skuList: skuList,
          radio: 0,
          // 多规格单选：默认选第一个
          batchPrice: skuList[0] ? skuList[0].price : 0,
          batchMinPrice: skuList[0] ? skuList[0].minPrice : 0,
          batchQuota: skuList[0] ? skuList[0].quota : 0
        };
      }).catch(function () {
        return null;
      });
    },
    removeProduct: function removeProduct(index) {
      this.productList.splice(index, 1);
    },
    editRow: function editRow(row) {
      var _this5 = this;
      this.editProduct = row;
      this.editTab = 'base';
      this.editVisible = true;
      this.$nextTick(function () {
        _this5.$refs.editForm && _this5.$refs.editForm.clearValidate();
      });
    },
    // 取参与砍价的 SKU：多规格取单选行，单规格取唯一行
    joinedSku: function joinedSku(product) {
      if (product.specType) {
        return product.skuList[product.radio] ? [product.skuList[product.radio]] : [];
      }
      return product.skuList;
    },
    confirmEdit: function confirmEdit() {
      var _this6 = this;
      this.$refs.editForm.validate(function (valid) {
        if (!valid) {
          _this6.editTab = 'base';
          return;
        }
        var joined = _this6.joinedSku(_this6.editProduct);
        if (!joined.length) return _this6.$message.warning('请选择一个参与砍价的规格');
        var _iterator = _createForOfIteratorHelper(joined),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var sku = _step.value;
            if (!sku.price || sku.price <= 0) return _this6.$message.warning('请填写砍价起始金额');
            if (sku.minPrice === '' || sku.minPrice === null || sku.minPrice < 0) return _this6.$message.warning('请填写砍价最低价');
            if (Number(sku.minPrice) > Number(sku.price)) return _this6.$message.warning('砍价最低价不能大于起始金额');
            if (!sku.quota || sku.quota <= 0) return _this6.$message.warning('请填写限量');
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this6.editVisible = false;
      });
    },
    // 列表内联改某字段 → 套用到该商品所有 SKU
    applyField: function applyField(product, skuKey, batchKey) {
      product.skuList.forEach(function (sku) {
        sku[skuKey] = product[batchKey];
      });
    },
    applyQuota: function applyQuota(product) {
      product.skuList.forEach(function (sku) {
        sku.quota = sku.stock ? Math.min(product.batchQuota, sku.stock) : product.batchQuota;
      });
    },
    modalPicTap: function modalPicTap(product, type) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (type === 'main' || type === 'sku') {
          _this.$set(product, 'image', img[0].sattDir);
        } else if (type === 'slider') {
          var rest = 10 - product.imagess.length;
          if (rest <= 0) return _this.$message.warning('最多选择10张图片！');
          img.slice(0, rest).forEach(function (item) {
            return product.imagess.push(item.sattDir);
          });
        }
      }, type === 'slider' ? '2' : '1', 'content');
    },
    removeSlider: function removeSlider(product, index) {
      product.imagess.splice(index, 1);
    },
    buildPayload: function buildPayload(product) {
      // 砍价只提交一个参与规格
      var attrValue = this.joinedSku(product).map(function (sku) {
        var row = Object.assign({}, sku);
        if (row.attrValue && _typeof(row.attrValue) === 'object') {
          row.attrValue = JSON.stringify(row.attrValue);
        }
        return row;
      });
      return {
        image: product.image,
        images: JSON.stringify(product.imagess),
        imagess: product.imagess,
        title: product.title,
        storeName: product.title,
        // 砍价单页提交时带 storeName，此处与活动名称保持一致
        unitName: product.unitName,
        sort: product.sort,
        tempId: this.baseForm.tempId,
        attr: product.attr,
        attrValue: attrValue,
        selectRule: product.selectRule,
        content: product.content,
        specType: product.specType,
        productId: product.productId,
        giveIntegral: product.giveIntegral,
        ficti: product.ficti,
        num: this.baseForm.num,
        peopleNum: this.baseForm.peopleNum,
        bargainNum: this.baseForm.bargainNum,
        startTime: this.baseForm.timeVal[0] || '',
        stopTime: this.baseForm.timeVal[1] || '',
        timeVal: this.baseForm.timeVal,
        status: this.baseForm.status
      };
    },
    validateProducts: function validateProducts() {
      if (!this.productList.length) {
        this.$message.warning('请先选择商品');
        return false;
      }
      var _iterator2 = _createForOfIteratorHelper(this.productList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var product = _step2.value;
          if (!product.title) {
            this.$message.warning('存在未填写砍价活动名称的商品');
            return false;
          }
          if (!product.image) {
            this.$message.warning("\u5546\u54C1\u300C".concat(product.storeName, "\u300D\u672A\u8BBE\u7F6E\u4E3B\u56FE"));
            return false;
          }
          if (!product.imagess || !product.imagess.length) {
            this.$message.warning("\u5546\u54C1\u300C".concat(product.storeName, "\u300D\u672A\u4E0A\u4F20\u8F6E\u64AD\u56FE"));
            return false;
          }
          if (!product.unitName) {
            this.$message.warning("\u5546\u54C1\u300C".concat(product.storeName, "\u300D\u672A\u586B\u5199\u5355\u4F4D"));
            return false;
          }
          var joined = this.joinedSku(product);
          if (!joined.length) {
            this.$message.warning("\u5546\u54C1\u300C".concat(product.storeName, "\u300D\u8BF7\u9009\u62E9\u4E00\u4E2A\u53C2\u4E0E\u780D\u4EF7\u7684\u89C4\u683C"));
            return false;
          }
          var _iterator3 = _createForOfIteratorHelper(joined),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var sku = _step3.value;
              if (!sku.price || sku.price <= 0) {
                this.$message.warning("\u5546\u54C1\u300C".concat(product.storeName, "\u300D\u672A\u586B\u5199\u780D\u4EF7\u8D77\u59CB\u91D1\u989D"));
                return false;
              }
              if (Number(sku.minPrice) > Number(sku.price)) {
                this.$message.warning("\u5546\u54C1\u300C".concat(product.storeName, "\u300D\u780D\u4EF7\u6700\u4F4E\u4EF7\u4E0D\u80FD\u5927\u4E8E\u8D77\u59CB\u91D1\u989D"));
                return false;
              }
              if (!sku.quota || sku.quota <= 0) {
                this.$message.warning("\u5546\u54C1\u300C".concat(product.storeName, "\u300D\u672A\u586B\u5199\u9650\u91CF"));
                return false;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return true;
    },
    handleSubmit: Debounce(function () {
      var _this7 = this;
      this.$refs.baseForm.validate(function (valid) {
        if (!valid) return;
        if (!_this7.validateProducts()) return;
        _this7.submitBatch();
      });
    }),
    submitBatch: function () {
      var _submitBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var results, _iterator4, _step4, product, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              this.fullscreenLoading = true;
              results = {
                success: [],
                fail: []
              };
              _iterator4 = _createForOfIteratorHelper(this.productList);
              _context.p = 1;
              _iterator4.s();
            case 2:
              if ((_step4 = _iterator4.n()).done) {
                _context.n = 7;
                break;
              }
              product = _step4.value;
              _context.p = 3;
              _context.n = 4;
              return bargainSaveApi(this.buildPayload(product));
            case 4:
              results.success.push(product.productId);
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              results.fail.push(product.productId);
            case 6:
              _context.n = 2;
              break;
            case 7:
              _context.n = 9;
              break;
            case 8:
              _context.p = 8;
              _t2 = _context.v;
              _iterator4.e(_t2);
            case 9:
              _context.p = 9;
              _iterator4.f();
              return _context.f(9);
            case 10:
              this.loading = false;
              this.fullscreenLoading = false;
              if (!results.fail.length) {
                this.$message.success("\u6210\u529F\u6DFB\u52A0 ".concat(results.success.length, " \u4E2A\u780D\u4EF7\u5546\u54C1"));
                this.$router.push('/marketing/bargain/bargainGoods');
              } else {
                this.productList = this.productList.filter(function (item) {
                  return results.fail.indexOf(item.productId) > -1;
                });
                this.$message.error("".concat(results.success.length, " \u4E2A\u6210\u529F\uFF0C").concat(results.fail.length, " \u4E2A\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u5931\u8D25\u5546\u54C1\u540E\u91CD\u8BD5"));
              }
            case 11:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5], [1, 8, 9, 10]]);
      }));
      function submitBatch() {
        return _submitBatch.apply(this, arguments);
      }
      return submitBatch;
    }()
  }
};